import serviceCalls from "../services/serviceCalls";
import { toastr } from "react-redux-toastr";

export const initiatePosting = async (data) => {
  try {
    let result = await serviceCalls.post("/api/create_post", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message[0]);
    } else {
      const id = result.data.id;
      const tags = result.data.description
        .split(" ")
        .filter((v) => v.startsWith("#"));
      if (tags.length > 0) {
        const data = {
          post_id: id,
          tag_name: tags,
        };
        addTagsToPost(data);
      }
      return result;
    }
  } catch (e) {
    return {};
  }
};

export const updatePost = async (data) => {
  try {
    let result = await serviceCalls.post("/api/update_post", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message[0]);
    } else {
      // const id = result.data.id
      // const tags = result.data.description.split(' ').filter(v => v.startsWith('#'))
      // if (tags.length > 0) {
      //     const data = {
      //         post_id: id,
      //         tag_name: tags
      //     }
      //     addTagsToPost(data)
      // }
      return result;
    }
  } catch (e) {
    return {};
  }
};

export const addTagsToPost = async (data) => {
  try {
    const result = await serviceCalls.post("/api/post_tags", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};

export const removeTagsFromPost = async (data) => {
  try {
    const result = await serviceCalls.post("/api/remove_post_tags", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};

export const initiateSharePost = async (data) => {
  try {
    let result = await serviceCalls.post("/api/share_post", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message[0]);
    } else {
      return result;
    }
  } catch (e) {
    return {};
  }
};

export const getAllPosts = async (data) => {
  try {
    const result = await serviceCalls.post(
      "/api/get_all_articles_posts",
      data,
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else if (result?.data?.message === "Unauthenticated.") {
      toastr.error("Unauthenticated", "Please Login to access services.");
      return {};
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Something went wrong with newsfeed");
    return {};
  }
};

export const getAllUserPosts = async (data) => {
  try {
    const result = await serviceCalls.post(
      `/api/get_user_posts/${data.user_id}`,
      data,
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else if (result?.data?.message === "Unauthenticated.") {
      toastr.error("Unauthenticated", "Please Login to access services.");
      return {};
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Something went wrong with newsfeed");
    return {};
  }
};

export const getAllPostsOfUser = async (data) => {
  try {
    const result = await serviceCalls.get(
      `/api/get_user_posts/${data.postId}`,
      data,
      true
    );
    if (!result) {
      throw new Error("Response Undefined");
    } else {
      return result;
    }
  } catch (e) {
    throw new Error("Response Undefined");
  }
};

export const getOnePosts = async (postId) => {
  try {
    const result = await serviceCalls.get(`/api/get_post/${postId}`, {}, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Soemthing went wrong.");
    return {};
  }
};

export const getPostsByTag = async (tagName) => {
  try {
    const result = await serviceCalls.post(
      `/api/get_posts_by_tag`,
      { name: tagName },
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Soemthing went wrong.");
    return {};
  }
};

export const deletePost = async (post) => {
  //   try {
  //     let result = await serviceCalls.post("/api/delete_post/" + id, {}, true);
  //     if (
  //       result?.status == 422 ||
  //       result?.status == "error" ||
  //       result?.data?.status == "error"
  //     ) {
  //       throw new Error(result?.data?.message[0]);
  //     } else {
  //       return result;
  //     }
  //   } catch (e) {
  //     return {};
  //   }
  
  try {
    const id = post?.id;
    const tags = post?.description?.split(" ").filter((v) => v.startsWith("#"));

    if (tags && tags.length >= 0) {
      const data = {
        post_id: id,
        tag_name: tags,
      };
      removeTagsFromPost(data);
    }
    const result = await serviceCalls.post(
      `/api/delete_post/${post?.id}`,
      {},
      true
      );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Soemthing went wrong.");
    return {};
  }
};

export const HidePost = async (postId) => {
  try {
    const result = await serviceCalls.post(
      `/api/hide_post/${postId}`,
      {},
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Soemthing went wrong.");
    return {};
  }
};

export const createComment = async (data) => {
  try {
    const result = await serviceCalls.post("/api/add_comment", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to add comment on post.");
    return {};
  }
};

export const AddlikeComment = async (data) => {
  try {
    const result = await serviceCalls.post("/api/like_comment", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
      
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform this operation.");
    return {};
  }
};

export const getAllComments = async (data) => {
  try {
    const result = await serviceCalls.get(
      "/api/get_post_comments/" + data.postId,
      {},
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to get comments.");
    return {};
  }
};

export const addReaction = async (data) => {
  try {
    const result = await serviceCalls.post("/api/like_post", data, true);
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};

export const getAllPostLikes = async (id) => {
  try {
    const result = await serviceCalls.get(
      `/api/get_post_likes/${id}`,
      {},
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};

export const getAllPostShare = async (id) => {
  try {
    const result = await serviceCalls.get(
      `/api/get_post_shares/${id}`,
      {},
      true
    );
    if (
      result?.status == 422 ||
      result?.status == "error" ||
      result?.data?.status == "error"
    ) {
      throw new Error(result?.data?.message);
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};

export const getPreviewLink = async (url) => {
  try {
    const result = await serviceCalls.get(
      `/api/get_link_preview?url=${url}`,
      {},
      false
    );
    if (result?.title === null || result?.title === undefined) {
      return {};
    } else {
      return result;
    }
  } catch (e) {
    toastr.error("Sorry!", "Not able to perform operation.");
    return {};
  }
};
